module.exports = __webpack_public_path__ + "omlazeni-pleti_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/laserova-estetika/omlazeni-pleti_2_after.jpg
// module id = 1015
// module chunks = 0